import { Injectable } from '@angular/core';
import { EnvironmentSpecificService } from '../../../../environment-specific.service';
import { Http } from '../../http-client/http-client.component';
import { Observable } from "rxjs/Observable";

@Injectable()
export class EditMetadataService {

    apiUrl:any;

    constructor(private _http: Http,
      private _envService: EnvironmentSpecificService
    ){
      this.apiUrl = this._envService.envSpecific.apiUrl;
    }

    getMetadata(id): Observable<any>{
        return this._http.get(this.apiUrl  + '/files/getmetadata/'+id).map((response) => {
            return response;
        });
    }

    UpdateMetaData(data): Observable<any> {
      return this._http.post(this.apiUrl  + '/files/updatemetadata',data).map((response: Response) => {
          return response;
      });
    }
    
}